import $ from "jquery";
// const API_BASE_URL = "https://qanodeapi.pb-online.co.in/api";
const API_BASE_URL = "https://api.wavespb.com/api";
// const API_BASE_URL = "https://node-api.pb-online.co.in/api";
// const API_BASE_URL = "https://sandbox-node-api.pb-online.co.in/api";
// const API_BASE_URL = "https://sbapi.wavespb.com/api";
// const API_BASE_URL = "https://qa1.pb-online.co.in/api";
export const fetchContent = async (path, method, headersparam, postParam = "") => {
  return new Promise((resolve, reject) => {
    // console.log("path ------", path);
    $.ajax({
      url: API_BASE_URL + path,
      headers: headersparam,
      method: method,
      cache: false,
      dataType: "json",
      timeout: 12000,
      data: postParam,
      error: function (err) {
        // console.log("Error ------- = ", err);
        reject(err);
      },
      success: function (data) {
        console.log("mainnnnnnnnnnn......", data);
        resolve(data);        
      },
    });
  });
};

export const fetchContent1 = async (path, method, headersparam, postParam = "") => {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: API_BASE_URL + path,
      headers: headersparam,
      method: method,
      cache: false,
      dataType: "json",
      timeout: 12000,
      contentType: "application/json", // Ensures the data is sent as raw JSON
      data: method === "POST" ? JSON.stringify(postParam) : postParam, // Stringify only for POST
      error: function (err) {
        reject(err);
      },
      success: function (data) {
        console.log("mainnnnnnnnnnn......", data);
        resolve(data);
      },
    });
  });
};

export const getBaseURL = () => {
  return API_BASE_URL
};
